import axios from "./_axios";
import { API } from "./apiEndPoints";

export const getDashboardStats = (account_id) => {
  let result = axios()({
    method: "get",
    url: `${API.ACCOUNTList}${account_id}/catalogs/`,
  });
  return result;
};
